/**
 * AI Assistant Module
 * The assistant card / bar (partials/assistant.php) and the login popup bar open the chat widget
 * <ecotex-chat> (chat.ecotexgroup.com, added outside the theme). A link set with the
 * ecotex_assistant_url filter is followed like a normal link.
 */
const assistant = {
    init() {
        $(document).on('click', '.assistant-cta[data-assistant-open], .assistant-cta [data-assistant-open]', function(e) {
            if ($(this).attr('href') !== '#') {
                return;
            }
            e.preventDefault();
            $(document).trigger('ecotex:assistant-open');
        });

        // Also emitted by the login popup (scripts/login-popup.js)
        $(document).on('ecotex:assistant-open', () => this.openChat());
    },

    openChat() {
        const chat = document.querySelector('ecotex-chat');

        // The widget builds its panel in a shadow root - no panel (script not loaded, page excluded) means nothing to open
        if (!chat || typeof chat.openPanel !== 'function' || !chat.shadowRoot || !chat.shadowRoot.querySelector('.panel')) {
            return;
        }

        chat.openPanel();
    },
};

export default assistant;
